import './Sky.css';

function Sky({ children }) {
    return (
        <div className="skyDiv1" >
            <div>{children}</div>
        </div>
    )
}

export default Sky;